// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__25hvS","savePackageButton":"ClientWallet_savePackageButton__1f_I-"};